import { render } from "./tables-basic.vue?vue&type=template&id=a51edb80"
import script from "./tables-basic.vue?vue&type=script&lang=js"
export * from "./tables-basic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__